import { LoyaltyTierName } from 'types/api/account.types';

const ALLOWED_TIER_NAMES = [
  'Bronze',
  'Silver',
  'Gold',
  'Platinum',
  'Diamond',
  'Royal',
] as const;

/**
 * Safety function to ensure that if a tier is returned from the API that is not in the allowed list, we default to Bronze
 * We don't want to show a tier that doesn't exist in the system
 */
export const safeTier = (
  tier: LoyaltyTierName | undefined | null,
): LoyaltyTierName => {
  if (!tier) return 'Bronze';

  if (ALLOWED_TIER_NAMES.includes(tier)) return tier;

  return 'Bronze';
};

const path = '/images/loyalty';

export const getMembershipCardIcon = (tier: LoyaltyTierName) => {
  if (tier === 'Royal') {
    return {
      nf: `${path}/logo-membership-card-nf-royal.webp`,
    };
  }

  if (tier === 'Diamond') {
    return {
      nf: `${path}/logo-membership-card-nf-diamond.webp`,
    };
  }

  return {
    nf: `${path}/logo-membership-card-nf.webp`,
  };
};
/**
 * Determines if a tier should be rendered based on its position and the current active tier.
 *
 * @param positionOfElement - Position of the element in the list to be rendered.
 * @param activeIndex - The selected tier index.
 * @param activeTierIndex - The current tier of the user.
 * @returns boolean - True if the tier should be rendered, otherwise false.
 */
export const shouldRenderTier = (
  positionOfElement: number,
  activeIndex: number,
  activeTierIndex: number,
): boolean => {
  const isActiveOrSelectedTier =
    positionOfElement === activeIndex || positionOfElement === activeTierIndex;

  const isNextTierSelected =
    positionOfElement === activeTierIndex + 1 &&
    activeIndex <= activeTierIndex + 1;

  const isPreviousTierSelected =
    positionOfElement === activeTierIndex - 1 &&
    activeIndex >= activeTierIndex - 1;

  return isActiveOrSelectedTier || isNextTierSelected || isPreviousTierSelected;
};

export const isTierBefore = (beforeIndex: number, afterIndex: number) =>
  beforeIndex < afterIndex;

export const isTierAfter = (beforeIndex: number, afterIndex: number) =>
  beforeIndex > afterIndex;

export const membershipIconLookup: Record<LoyaltyTierName, string> = {
  Bronze: '/images/loyalty/ico-56-membership-black.webp',
  Silver: '/images/loyalty/ico-56-membership-black.webp',
  Gold: '/images/loyalty/ico-56-membership-black.webp',
  Platinum: '/images/loyalty/ico-56-membership-black.webp',
  Diamond: '/images/loyalty/ico-56-membership-diamond.webp',
  Royal: '/images/loyalty/ico-56-membership-royal.webp',
};
